<template>
  <div class="milestones_1_container">
    <div class="milestones_1_top">
      <div class="milestones_1_top_1">
        <div>Milestones</div>
      </div>
      <div class="milestones_1_top_2">
        <div>Color</div>
      </div>
      <div class="milestones_1_top_3">
        <div>No.</div>
      </div>
    </div>
    <div class="milestones_1_content">
      <div v-for="(stage, index) in all_stages" class="milestones_1_content_item"
           :style="{borderBottom:'#EEEEEE solid 1px'}">
        <div class="milestones_1_top_1">
          <div style="width: 95%; font-size: 0.8rem">{{ stage.stage_name }}</div>
        </div>
        <div class="milestones_1_top_2" :style="{backgroundColor: stage.stage_color}">
        </div>
        <div class="milestones_1_top_3" style="font-size: 0.9rem; overflow: hidden">
          <div>{{ stage.stage_cnt }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "milestones_1",
  props: ['all_stages'],
}
</script>

<style scoped>
.milestones_1_container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: scroll;
}

.milestones_1_top {
  display: flex;
  width: calc(100% - 3px);
  border: #EEEEEE 1px solid;
  height: 15%;
  font-size: 1rem;
  color: white;
}

.milestones_1_top_1 {
  width: calc(62% - 1px);
  border-right: #EEEEEE 1px solid;
  height: 100%;
  margin-left: 2%;
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  text-align: left;
}

.milestones_1_top_2 {
  width: calc(18% - 1px);
  border-right: #EEEEEE 1px solid;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.milestones_1_top_3 {
  width: 17%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.milestones_1_content {
  width: 100%;
  height: 81%;
  display: flex;
  flex-direction: column;
  overflow: scroll;
}

.milestones_1_content_item {
  width: calc(100% - 3px);
  min-height: 18%;
  /*height: 36px;*/
  border-bottom: #EEEEEE 1px solid;
  border-left: #EEEEEE 1px solid;
  border-right: #EEEEEE 1px solid;
  font-size: 1.2rem;
  color: white;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/fabrication/milestones_1.vue